import {
    DateInput,
    Edit,
    minLength, ReferenceField,
    ReferenceInput,
    required, SaveButton,
    SelectInput, Show,
    SimpleForm, SimpleShowLayout, TextField,
    TextInput, Toolbar,
} from "react-admin";
import React, { useState, useEffect } from 'react';
import { useDataProvider } from 'react-admin';


export const BookEdit = ({ userId }) => {
    const dataProvider = useDataProvider();
    const [user, setUser] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    useEffect(() => {
        dataProvider.getOne('users', { id: 1 })
            .then(({ data }) => {
                setUser(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })
    }, []);

    if (!user) return null;

    return (
        <>
            <Show>
                <SimpleShowLayout>
                    <TextField source="id" />
                    <TextField source="title" />
                    <ReferenceField source="author_id" reference="authors" />
                    <TextField source="year" />
                </SimpleShowLayout>
            </Show>

            <Edit>
                <SimpleForm toolbar={<Toolbar><SaveButton /></Toolbar>} redirect={false} >
                    <TextInput disabled source="email" />
                    <TextInput source="first_name" label="First Name" validate={required()} />
                    <TextInput source="email"  label="Last Name"  validate={required()} />
                </SimpleForm>
            </Edit>
        </>

    )
};